// @flow strict

import * as React from 'react';

export default () => {
  return <></>;
};
